import component from './PhToggleRight.vue_vue_type_script_lang.vue.js';
export { default } from './PhToggleRight.vue_vue_type_script_lang.vue.js';
import { render } from './PhToggleRight.vue_vue_type_template_id_51906e98_lang.vue.js';

component.render = render;
